import ICONS from "../assets/Icons";
import CommonToast from "../components/_utils/CommonToast";
import { PaginationConfiguration } from "./configurationProvider";

const useMultiSelect = () => {
  const handleSelectAll = (
    selectedState,
    setSelectedState,
    currentSize,
    data,
    selectKey = "id",
  ) => {
    if (!selectedState?.length) {
      setSelectedState(() => {
        return data?.slice(0, Number(currentSize));
      });
    } else if (
      selectedState?.length === Number(currentSize) ||
      selectedState?.length === Number(data?.length)
    ) {
      setSelectedState([]);
    } else {
      let arr = [...selectedState];
      for (let i = 0; i < Number(currentSize); i++) {
        if (arr?.length < Number(currentSize)) {
          if (
            !selectedState?.some(
              (itm) => itm?.[selectKey] === data?.[i]?.[selectKey],
            )
          ) {
            if (data?.[i]?.[selectKey] !== undefined) {
              arr.push(data[i]);
            }
          }
        }
      }
      setSelectedState(arr);
    }
  };

  const handleSingleSelect = (
    selectedState,
    setSelectedState,
    currentSize,
    data,
    selectKey = "id",
  ) => {
    if (selectedState?.some((itm) => itm?.[selectKey] === data?.[selectKey])) {
      setSelectedState((prev) => {
        return prev?.filter((acc) => {
          return acc?.[selectKey] !== data?.[selectKey];
        });
      });
    } else {
      if (selectedState?.length < Number(currentSize)) {
        setSelectedState((prev) => [...prev, data]);
      } else {
        CommonToast({
          text: "Maximum limit reached.",
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  const handleChange = (
    selectedState,
    setSelectedState,
    currentSize,
    data,
    selectKey = "id",
  ) => {
    if (
      currentSize === PaginationConfiguration.paginationSmall &&
      selectedState?.length > PaginationConfiguration.paginationSmall
    ) {
      let arr = [];
      for (let i = 0; i < Number(currentSize); i++) {
        if (arr?.length < Number(currentSize)) {
          if (data?.[i]?.[selectKey] !== undefined) {
            arr.push(data[i]);
          }
        }
      }
      setSelectedState(arr);
    }
  };

  return { handleChange, handleSelectAll, handleSingleSelect };
};

export default useMultiSelect;
